import * as React from 'react';

// tslint:disable:max-line-length
export const StadiumIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      fillRule="nonzero"
      d="M16 5c0-2.243-3.514-4-8-4-4.486 0-8 1.757-8 4 0 .024 1 7 1 7 0 1.565 2.327 2.549 5 2.877V12h4v2.878c2.673-.326 5-1.3 4.995-2.808C15 12.07 16 5.024 16 5zM8 7C4.128 7 2 5.5 2 5s2.128-2 6-2 6 1.5 6 2-2.128 2-6 2z"
    />
  </svg>
);
